"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z
    .object({
    statementId: zod_1.z.string().uuid().optional().nullable(),
    statementIds: zod_1.z.array(zod_1.z.string().uuid()).optional().nullable(),
    feedbackType: zod_1.z.union([zod_1.z.literal('like'), zod_1.z.literal('dislike'), zod_1.z.literal('view'), zod_1.z.null()]),
    meta: zod_1.z
        .object({
        appName: zod_1.z.string().nullable().optional(),
        appVersion: zod_1.z.string().nullable().optional(),
        appContext: zod_1.z.string().nullable().optional(),
        selectedValueGroups: zod_1.z.array(zod_1.z.string()).optional().nullable(),
        otherJSON: zod_1.z.string().optional().nullable(),
    })
        .optional(),
})
    .refine((args) => {
    if (!args.statementId && !args.statementIds) {
        return false;
    }
}, { message: 'Must provide either statementId or statementIds' });
exports.path = '/log-sidekick-feedback';
//# sourceMappingURL=index.js.map